import request from 'utils/request'
import {stringify} from 'qs'
import api from './api'

// 客户数预警列表
export async function getWarningList(payload) {
    return request(`${api.getWarningList.url}?${stringify(payload)}`)
}
